import { Component, Injector, OnDestroy, ViewChild, Input, OnInit } from '@angular/core';

import { BaseFormComponent } from '../base-form.component';
import { BasicTextInputComponent } from '../basic-text-input/basic-text-input.component';

@Component({
  moduleId: module.id,
  selector: 'text-date-long',
  templateUrl: './text-date-long.component.html',
})
export class TextDateLongComponent extends BaseFormComponent implements OnInit {
  @ViewChild('textInputComponent', { static: true }) textInputComponent: BasicTextInputComponent;
  inputDate: string;
  @Input() disableConditionally: boolean = false;
  @Input() propertyName: string;
  @Input() mask = {
    guide: true,
    mask: [/^([0-1])/, /\d/, '/', /^(0|1|2|3)/, /\d/, '/', /^(1|2)/, /^(9|0|1)/, /\d/, /\d/],
    placeholder: 'MM/DD/YYYY',
  };

  constructor(protected injector: Injector) {
    super(injector);
    this.questionItem = this.injector.get('questionItem');

    this.updateFromModel(); // For the initial value
  }

  ngOnInit() {
    this.textInputComponent.obfuscationPattern = '••/••/••••';
  }

  updateFromModel() {
    this.inputDate = this.formatterSvc.formatUTCDate(this.getValue(this.questionItem.prop));
  }

  resetValue() {
    this.inputDate = '';
    this.textInputComponent.resetValue();
  }

  async trigger() {
    await this.validateAndSet(this.questionItem.prop, this.inputDate);
  }
}
